import { getApiAsynWithBase, getApiAsynarrayBuffer } from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL, pyApiURL } from "../../../../utils/constant";
import { formatDatesHyphan } from "../../../../utils";

const buildQueryParams = (payload) => {
  const filters = payload?.additinalFilter || {};
  const startDate = formatDatesHyphan(filters.startDate);
  const endDate = formatDatesHyphan(filters.endDate);

  let params = `?start_date=${startDate}&end_date=${endDate}`;

  if (filters.location) {
    params += `&location_id=${filters.location}`;
  }
  if (filters.network) {
    params += `&network_id=${filters.network}`;
  }
  if (filters.type) {
    params += `&type=${filters.type}`;
  }

  const page = (payload?.pageNumber ?? 0) + 1;
  const pageSize = payload?.pageSize || 10;
  params += `&page=${page}&page_size=${pageSize}`;

  return params;
};

export const fetchRevenueByNetwork = async (payload) => {
  const queryParams = buildQueryParams(payload);
  const url = API_URL.REVENUE_BY_NETWORK.GET + queryParams;
  try {
    let result = await getApiAsynWithBase(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const exportRevenueByNetworkRecord = async (payload) => {
  const filters = payload?.additinalFilter || {};
  const startDate = formatDatesHyphan(filters.startDate);
  const endDate = formatDatesHyphan(filters.endDate);

  let params = `?start_date=${startDate}&end_date=${endDate}`;
  if (filters.location) {
    params += `&location_id=${filters.location}`;
  }
  if (filters.network) {
    params += `&network_id=${filters.network}`;
  }
  if (filters.type) {
    params += `&type=${filters.type}`;
  }

  const fullUrl = pyApiURL + API_URL.REVENUE_BY_NETWORK.EXPORT + params;
  try {
    let result = await getApiAsynarrayBuffer(fullUrl, localStorage.getItem("token"), false);
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
